/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookNotificationConfigurationData } from '../../models/book-notification-configuration-data';

export interface GetBookNotificationConfigData$Params {

/**
 * id of configuration type book
 */
  bookId: string;
}

export function getBookNotificationConfigData(http: HttpClient, rootUrl: string, params: GetBookNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<BookNotificationConfigurationData>> {
  const rb = new RequestBuilder(rootUrl, getBookNotificationConfigData.PATH, 'get');
  if (params) {
    rb.path('bookId', params.bookId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BookNotificationConfigurationData>;
    })
  );
}

getBookNotificationConfigData.PATH = '/api/configuration/book/{bookId}/notification';
